import React from "react";
import CardGallery from "./Cards/CardGallery";
import { RxArrowRight, RxArrowLeft } from "react-icons/rx";

export default function Gallery() {
  return (
    <>
      <h1
        className="text-2xl sm:text-4xl 2xl:text-5xl font-bold text-center mt-28 lg:mt-32"
        id="galleries"
      >
        Galeri Klinik
      </h1>
      <p className="mt-4 text-center text-gray-500 2xl:mt-8">
        Beberapa foto klinik kami
      </p>
      <div className="relative  container lg:mx-auto lg:flex lg:items-center lg:justify-center">
        <RxArrowLeft className="hidden lg:block 2xl:text-4xl font-bold  text-gray-300" />
        <CardGallery />
        <RxArrowRight className="hidden lg:block 2xl:text-4xl font-bold cursor-pointer hover:text-blue-300" />
      </div>
    </>
  );
}
